import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberFormat'
})
export class NumberFormatPipe implements PipeTransform {

  transform(value: number | string): string {
    if (value == null) return ''; // Handle null or undefined input

    let stringValue: string;

    if (typeof value === 'number') {
      stringValue = value.toFixed(2); // Ensure the number has two decimal places
    } else {
      stringValue = parseFloat(value).toFixed(2);
    }

    const [integerPart, decimalPart] = stringValue.split('.');
    let result = '';
    let len = integerPart.length;
    let counter = 0;

    for (let i = len - 1; i >= 0; i--) {
      counter++;
      result = integerPart[i] + result;
      if (counter === 3 && i > 0) {
        result = ',' + result;
        counter = 0;
      } else if (counter > 3 && (counter - 2) % 2 === 0 && i > 0) {
        result = ',' + result;
      }
    }

    return result + '.' + decimalPart;
  }
}
